import { render, staticRenderFns } from "./receivable-batch-dialog.vue?vue&type=template&id=22f66075&"
import script from "./receivable-batch-dialog.vue?vue&type=script&lang=js&"
export * from "./receivable-batch-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports